const regEmail =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
// const regPhone = /^\d{2,3}-\d{3,4}-\d{4}$/;
const regPhone = /^(02|0[3-7][1-6]|01[0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
const regPasswd = /^(?=.*[!@#$%^&*()_+{}|:;'"<>?,./])\S{7,}$/;
const regScript = /<script\b|&lt;script\b/i;
const regSellerCode = /^[a-zA-Z0-9]+$/;

export { regEmail, regPhone, regPasswd, regScript, regSellerCode };
